var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/video-mute",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.293,3.2929 C3.684,2.9019 4.316,2.9019 4.707,3.2929 L4.707,3.2929 L20.707,19.2929 C21.098,19.6839 21.098,20.3159 20.707,20.7069 C20.512,20.9019 20.256,20.9999 20,20.9999 C19.744,20.9999 19.488,20.9019 19.293,20.7069 L19.293,20.7069 L3.293,4.7069 C2.902,4.3159 2.902,3.6839 3.293,3.2929 Z M2.9736,5.8017 L3.1196,5.9477 L14.2236,17.0517 L15.6646,18.4927 C15.1886,18.8127 14.6166,18.9997 13.9996,18.9997 L13.9996,18.9997 L4.9996,18.9997 C3.3456,18.9997 1.9996,17.6547 1.9996,15.9997 L1.9996,15.9997 L1.9996,7.9997 C1.9996,7.1287 2.3786,6.3507 2.9736,5.8017 L2.9736,5.8017 Z M13.9997,4.9994 C15.6547,4.9994 16.9997,6.3454 16.9997,7.9994 L16.9997,7.9994 L16.9997,9.4514 L19.1607,7.4514 C19.6597,6.9914 20.3857,6.8734 21.0117,7.1454 C21.6207,7.4114 21.9997,7.9804 21.9997,8.6294 L21.9997,8.6294 L21.9997,15.3704 C21.9997,16.0194 21.6207,16.5884 21.0117,16.8544 C20.7877,16.9524 20.5527,16.9994 20.3197,16.9994 C20.1137,16.9994 19.9097,16.9614 19.7177,16.8894 L19.7177,16.8894 L7.8277,4.9994 L13.9997,4.9994 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMute);
export default __webpack_public_path__ + "static/media/video-mute.298ab1cd.svg";
export { ForwardRef as ReactComponent };